const ENTITY_LABELS = {
    team: 'A team',
    task: 'A task',
    user: 'A user',
    photo: 'A photo',
    video: 'A video',
    reward: 'A reward',
    game: 'A game',
    answer: 'An answer',
    comment: 'A comment',
    zone: 'A zone',
    designation: 'A designation',
    npc: 'An NPC',
    badge: 'A badge',
    admin: 'An admin',
    coordinator: 'A coordinator',
    group: 'A group',
    reel: 'A reel',
    personalization: 'A personalization',
    super: 'A super admin',
    token: 'Push token',
    hint: 'A hint',
    chat: 'A chat message',
    media: 'A media asset',
    reelGenerated: 'A reel',
    score: 'Score',
    analytic: 'Analytics',
    waypoint: 'A waypoint',
    position: 'A position',
    stream: 'A stream',
    export: 'Export',
    library: 'Library',
    slideshow: 'Slideshow',
    adjustment: 'An adjustment'
}

const ACTION_LABELS = {
    create: 'created',
    delete: 'deleted',
    update: 'updated',
    upload: 'uploaded',
    processed: 'processed',
    feature: 'featured',
    flag: 'flagged',
    review: 'reviewed',
    reject: 'rejected',
    accept: 'accepted',
    merge: 'merged',
    unmerge: 'unmerged',
    like: 'liked',
    unlike: 'unliked',
    clone: 'cloned',
    reel: 'generated',
    score: 'updated',
    search: 'performed',
    seen: 'updated',
    token: 'updated',
    reset: 'reset',
    signin: 'signed in',
    verify: 'verified',
    hint: 'used',
    live: 'started',
    media: 'processed',
    order: 'reordered',
    connect: 'connected',
    join: 'joined',
    leave: 'left',
    ban: 'banned',
    unban: 'unbanned',
}

export function getEventTemplateParts(eventName = '') {
    const parts = eventName.split('.')
    if (parts.length < 3) return null

    const [, rawEntity, rawAction] = parts

    const eventKey = ENTITY_LABELS[rawEntity] || `A ${rawEntity}`
    const eventAction = ACTION_LABELS[rawAction] || rawAction

    return { eventKey, eventAction }
}
